export default {"src":"/_next/static/media/features-instantly-masks-on-the-go.7eb2081e.svg","height":401,"width":503,"blurWidth":0,"blurHeight":0};